<template lang="pug">
  include ./../../mixins
  +b.social-row
    +e.item(v-for="network in networks", :key="network.network")
      share-network.share-link(
        :network="network.network"
        :style="{backgroundColor: network.color}"
        :url="sharing.url"
        :title="sharing.title"
        :description="sharing.description"
        :quote="sharing.quote"
        :hashtags="sharing.hashtags"
        :twitterUser="sharing.twitterUser"
      )
        +b.I.icon(:class="`${network.icon}`")
    +e.item
      +b.I.share-link--black(
        :title="_('Copy link')",
        v-clipboard:copy="params.url",
        v-clipboard:success="onCopy"
        )
        +b.I.icon.--type_copy
</template>


<script>
export default {
  name: "Sharing",
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      sharing: {
        url: this.params.url,
        title: this.params.title,
        description: this.params.description,
      },
      networks: [
        { network: 'facebook', name: 'Facebook', icon: 'icon--type_fb'},
        { network: 'twitter', name: 'Twitter', icon: 'icon--type_twt'},
      ]
    }
  },
  methods: {
    onCopy(e) {
      this.$notify({
        title: this._("Link has copied")
      })
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/js/components/Uploader/Sharing.vue